import React, { Component } from 'react';
import { Tooltip, Icon } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';

class Filter extends Component {
    render () {
        const { ...rest } = this.props;
        const tipInfo = (
            <span>
                1、自然月，表示每月统计的数据范围，<br />
                为本月1号~月底产生的数据。<br />
                2、工时结算月，表示每月统计的数据<br />
                范围，为上月26号~本月25号产生的数据。
            </span>
        );
        const tip = (
            <Tooltip placement="top" title={tipInfo}>
                <a><Icon style={{ marginRight: -8, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
            </Tooltip>
        );
        const filters = [{
            name: '统计维度',
            key: 'settlementType',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'BILLING_MONTH', label: '按工时结算月' },
                    { value: 'NATURAL_MONTH', label: '按自然月' },
                ],
                style: { width: 120 },
            }
        }, {
            name: tip,
            key: 'tip',
            type: 'text',
        }, {
            name: '公司名称',
            key: 'keyword',
            type: 'input',
        }];
        return <FilterBasic filters={filters} {...rest} />;
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/competeCompany/Compare/Filter.js